import classNames from "classnames";
import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { Field, getFormValues, reduxForm } from "redux-form";
import { EnumWrapper } from "../../../../../../utils/enums";
import { COUNTRIES, LANGUAGE_CODES, PROVINCES } from "../../../../../../utils/enums/enums";
import { FINANCE, FINTECH, INFORMATION_AGENT, PLAN_ADMINISTRATOR } from "../../../../../../utils/Roles";
import userHasAccess from "../../../../../../utils/userHasAccess";
import { MessageBox, Render } from "../../../../../common";
import { DayPicker, NewSelectInput, SelectInput, TextInput } from "../../../../../common/form";

import _, { isEqualWith } from "lodash";
import validationUtils from "../../../../../../utils/ValidationUtils";
import BU from "../../../../admin/enums/accountBusinessUnits";
import { MANUAL, RECURRING } from "../../../enums/billingPeriodTypes";
import genders from "../enums/genders";
import memberPayFrequencies from "../enums/memberPayFrequencies";
import { MEMBERS_VALIDATION_RULES } from "../membersValidationRules";
import SyncDeactivationButton from "../SyncDeactivationButton";
import { TERMINATED } from "../../../enums/clientStatusTypes";
import { ELIGIBILITY } from "../../../enums/synchronizationOptions";
import { toast } from "react-toastify";
import moment from "moment";
import { GM } from "../../../enums/businessAccountTypes";

class MemberProfileForm extends React.Component {
    static generateLocalizedRules(values, initialValues, member) {
        const rules = _.cloneDeep(MEMBERS_VALIDATION_RULES);
        Object.keys(values).forEach((key) => {
            if (
                rules[key] &&
                rules[key].hasOwnProperty("isRequiredTrim") &&
                rules[key]["isRequiredTrim"]["value"] == true
            ) {
                if (initialValues[key] == "" || initialValues[key] == null) {
                    delete rules[key].isRequiredTrim;
                }
            }
            if (key == "provincialHealthNumber") {
                rules[key] = MEMBERS_VALIDATION_RULES[key];
                rules[key] = {
                    ...rules[key],
                    isRequiredTrim: { value: true },
                };
            }

            if (key === "memberIdentifier" && member && member.client && member.client.businessAccountType === GM.value) {
                rules[key] = { ...rules[key], regex: { value: { pattern: /^\d*$/, customMessageKey: "validation.onlyNumerical" } } };
            }
        });
        return rules;
    }
    constructor(props) {
        super(props);
        this.fieldRefs = {};
        this.state = {
            showHealthCardInput: this.props.member.isCanadian === false,
            countryCode: this.props.member.countryCode,
            areAllFieldsDisabled: true,
            submittingToggle: false,
            currentFormValues: undefined,
            isFormUnchanged: true
        };
        this.displayErrorMessages = this.displayErrorMessages.bind(this);
        this.isBirthdateDisabled = this.isBirthdateDisabled.bind(this);
        this.handleCanadianChange = this.handleCanadianChange.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.setSubmittingToggle = this.setSubmittingToggle.bind(this);
        this.checkAndSetFieldsAccessibility = this.checkAndSetFieldsAccessibility.bind(this);
        this.setFieldRef = this.setFieldRef.bind(this);
        this.resetFormChangedStatus = this.resetFormChangedStatus.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);

        this.isBeforeUnloadEventAttached = false;
    }

    componentDidMount() {
        this.checkAndSetFieldsAccessibility();
    }

    componentDidUpdate(prevProps) {
        const { formValues } = this.props;
        const { currentFormValues } = this.state;

        if (currentFormValues === undefined && prevProps.formValues === undefined && formValues) {
            this.setState({ currentFormValues: formValues });
        }

        else if (prevProps.formValues && !isEqualWith(prevProps.formValues, formValues, this.isEqualCustomizer) && currentFormValues) {
            /**
             * Only enter condition if prevProps.formValues is truthy, to avoid entering condition when user did not do any changes to the form.
             * First check if prevProps and current prop are different for form.
             * Then check if currentFormValues state is equal to the current form values.
             */
            const formValuesCopy = this.removeUnnecessaryKeysAndAdjustObject(JSON.parse(JSON.stringify(formValues)));
            const currentFormValuesCopy = this.removeUnnecessaryKeysAndAdjustObject(JSON.parse(JSON.stringify(currentFormValues)));
            const isFormUnchanged = isEqualWith(formValuesCopy, currentFormValuesCopy, this.isEqualCustomizer, true);

            if (this.state.isFormUnchanged !== isFormUnchanged) {
                if (!isFormUnchanged) {
                    window.addEventListener("beforeunload", this.handleBeforeUnload);
                } else {
                    window.removeEventListener("beforeunload", this.handleBeforeUnload);
                }
                this.setState({ isFormUnchanged });
            }
        }
    }

    componentWillUnmount() {
        const { isFormUnchanged } = this.state;

        if (isFormUnchanged === false) {
            toast(
                <FormattedMessage
                    id="members.form.formChangeWarning"
                />,
                {
                    type: toast.TYPE.WARNING,
                    autoClose: 5000,
                }
            );
        }
        window.removeEventListener("beforeunload", this.handleBeforeUnload);
    }

    resetFormChangedStatus(formUnChangedValue, currentFormValues) {
        window.removeEventListener("beforeunload", this.handleBeforeUnload);
        this.setState({ isFormUnchanged: formUnChangedValue, currentFormValues });
    }

    handleBeforeUnload(e) {
        e.preventDefault();
        e.returnValue = '';
    }

    removeUnnecessaryKeysAndAdjustObject = (obj) => {
        delete obj["customEmailAddress"];
        delete obj["customInformation"];
        delete obj["customPhoneNumber"];
        delete obj["isSyncDisabled"];
        delete obj["country"];

        if (obj["provinceCode"] && obj["provinceCode"] === "noProvinces") {
            obj["provinceCode"] = null;
        }

        return obj;
    }

    isEqualCustomizer(objValue, otherValue) {
        if (typeof objValue === "boolean") {
            objValue = objValue.toString();
        }
        if (typeof otherValue === "boolean") {
            otherValue = otherValue.toString();
        }

        const isStringOrInt = (value) => typeof value === 'string' || typeof value === "number";
        if ((typeof objValue === 'string' && objValue.trim() === "" && otherValue === null)
            || (typeof otherValue === 'string' && otherValue.trim() === "" && objValue === null)) {
            /** We sometimes set null values as " " (e.g. for N/D) */
            return true;
        }
        if (String(objValue) === String(otherValue) && isStringOrInt(objValue) && isStringOrInt(otherValue)) {
            /** Some int field values are transformed to string once the field is focused. */
            return true;
        }
        const normalizeToMoment = (value) => {
            if (value instanceof moment) {
                return value.utc().startOf('day');
            }
            if (value instanceof Date || typeof value === 'string') {
                const ISO_8601_FULL_DATE_WITH_MS = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
                const ISO_8601_FULL_DATE_WITHOUT_MS = 'YYYY-MM-DDTHH:mm:ssZ';
                return moment(value, ['YYYY-MM-DD', 'YYYY/MM/DD', ISO_8601_FULL_DATE_WITH_MS, ISO_8601_FULL_DATE_WITHOUT_MS], true).utc().startOf('day');
            }
        };
        const normalizedObjValue = normalizeToMoment(objValue);
        const normalizedOtherValue = normalizeToMoment(otherValue);

        if (normalizedObjValue && normalizedOtherValue && normalizedObjValue.isValid() && normalizedOtherValue.isValid()) {
            /**
             * We need valid check in case we are checking strings. We want to make sure that they are actually dates.
             */
            return normalizedObjValue.isSame(normalizedOtherValue, 'day');
        }
    }

    setFieldRef(id, ref) {
        if (ref) {
            this.fieldRefs[id] = ref;
        }
    }

    checkAndSetFieldsAccessibility() {
        const areAllFieldsDisabled = Object.values(this.fieldRefs).every(field => field && field.props.disabled === true);
        this.setState({ areAllFieldsDisabled });
    }

    displayErrorMessages(messageId) {
        return (
            <div className="form-group">
                <span className="help-block-custom">
                    <FormattedMessage id={messageId} />
                </span>
            </div>
        );
    }

    handleCanadianChange(event) {
        const isFalse = event.target.value === "false";
        this.props.changeFieldValue("memberForm", "provincialHealthNumber", null);
        isFalse && this.props.touch("memberForm", "provincialHealthNumber");
        this.setState({
            showHealthCardInput: isFalse,
        });
    }

    handleCountryChange(event) {
        this.setState({
            countryCode: event.target.value,
        });
    }

    isBirthdateDisabled(memberClient, isEditable, shouldImportWithoutId) {
        if (!this.props.isAllowed) {
            return true;
        }
        if (BU.PM === memberClient.businessAccountType && memberClient.clientBillingPeriodType == MANUAL.value) {
            return false;
        }
        return !isEditable && !shouldImportWithoutId;
    }

    setSubmittingToggle(value) {
        this.setState({ submittingToggle: value });
    }

    handleFormSubmit(values) {
        this.props.onSubmit(values);
        this.resetFormChangedStatus(true, values);
    }

    render() {
        const placeholder = this.context.intl.formatMessage({ id: "common.nd" });
        const datePlaceholer = "DD/MM/YYYY";
        const {
            changeFieldValue,
            member: {
                isEditable,
                isArchived,
                client: { shouldImportWithoutId, isAutomaticMemberIdentifier, syncType, businessAccountType, clientBillingPeriodType },
            },
            roleId,
            isAllowed,
            submitting,
            handleSubmit
        } = this.props;
        const isMemberIdentifierDisabled = !userHasAccess(FINTECH) && (isAutomaticMemberIdentifier || (syncType === ELIGIBILITY.value) && (businessAccountType !== BU.PM));
        let classes = {
            "has-error": false,
        };
        if (this.props.isExistingMemberIdentifier) {
            classes["has-error"] = this.props.isExistingMemberIdentifier;
        }
        // `shouldImportWithoutId` is used with the `birthdate` field to override `isEditable`;
        //  If `shouldImportWithoutId` is true, then `birthdate` remains editable, regardless if `isEditable`'s value
        const memberIdentifierClassNames = classNames(classes);
        const memberClient = this.props.member.client;
        const countryCode = this.state.countryCode;
        const isBirthdateDisabled = this.isBirthdateDisabled(memberClient, isEditable, shouldImportWithoutId);

        const isTerminatedClient = !userHasAccess(FINTECH) && memberClient && memberClient.clientStatusType === TERMINATED.value;
        const isArchivedMember = !userHasAccess(FINTECH) && isArchived;
        const displayIsInternationalField = (this.props.isInternationalFeatureEnabledForRecurring && clientBillingPeriodType == RECURRING.value) || clientBillingPeriodType != RECURRING.value;

        return (
            <form className="member-form clearfix" onSubmit={handleSubmit(this.handleFormSubmit)}>
                <fieldset disabled={isTerminatedClient || isArchivedMember}>
                    <div className="member-perso-info">
                        {syncType === ELIGIBILITY.value && (
                            <div className="d-flex deactivate-sync-toggle">
                                <h3>
                                    <FormattedMessage id="members.form.persoInfo" />
                                </h3>
                                <SyncDeactivationButton setSubmittingToggle={this.setSubmittingToggle} member={this.props.member} />
                            </div>
                        )}
                        <Field
                            id="memberIdentifier"
                            name="memberIdentifier"
                            type="text"
                            groupClassName={memberIdentifierClassNames}
                            component={TextInput}
                            placeholder={placeholder}
                            label={<FormattedMessage id="members.form.memberIdentifier" />}
                            ref={ref => this.setFieldRef("memberIdentifier", ref)}
                            disabled={!isEditable || isMemberIdentifierDisabled || this.props.isArchived}
                            fieldTooltip={
                                roleId === PLAN_ADMINISTRATOR.roleId ? (
                                    <FormattedMessage id="common.reservedField" />
                                ) : null
                            }
                        />
                        {this.props.isExistingMemberIdentifier &&
                            this.displayErrorMessages(
                                "validation.customMessages.serverErrors.duplicateMemberIdentifier"
                            )}

                        {shouldImportWithoutId && (
                            <Field
                                placeholder={datePlaceholer}
                                id="memberIdentifierRecoveryDate"
                                name="memberIdentifierRecoveryDate"
                                component={DayPicker}
                                disabled={this.props.isArchived || !isAllowed}
                                label={<FormattedMessage id="members.form.memberIdentifierRecoveryDate" />}
                                ref={ref => this.setFieldRef("memberIdentifierRecoveryDate", ref)}
                            />
                        )}
                        <Field
                            id="firstName"
                            name="firstName"
                            type="text"
                            component={TextInput}
                            placeholder={placeholder}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.firstName" />}
                            ref={ref => this.setFieldRef("firstName", ref)}
                        />
                        <Field
                            id="lastName"
                            name="lastName"
                            type="text"
                            component={TextInput}
                            placeholder={placeholder}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.lastName" />}
                            ref={ref => this.setFieldRef("lastName", ref)}
                        />
                        <Field
                            id="phoneNumber"
                            name="phoneNumber"
                            type="text"
                            component={TextInput}
                            placeholder={placeholder}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.phoneNumber" />}
                            ref={ref => this.setFieldRef("phoneNumber", ref)}
                        />
                        <Field
                            id="emailAddress"
                            name="emailAddress"
                            type="text"
                            component={TextInput}
                            placeholder={placeholder}
                            disabled={
                                (!isEditable &&
                                    (!memberClient.name.toLowerCase().includes("agecro") ||
                                        (userHasAccess([FINANCE, INFORMATION_AGENT], true) &&
                                            memberClient.clientBillingPeriodType == MANUAL.value))) ||
                                this.props.isArchived
                            }
                            label={<FormattedMessage id="members.form.emailAddress" />}
                            ref={ref => this.setFieldRef("emailAddress", ref)}
                        />
                        <Field
                            placeholder={datePlaceholer}
                            id="birthdate"
                            name="birthdate"
                            component={DayPicker}
                            disabled={isBirthdateDisabled || this.props.isArchived}
                            label={<FormattedMessage id="members.form.birthdate" />}
                            ref={ref => this.setFieldRef("birthdate", ref)}
                        />
                        <Field
                            id="socialInsuranceNumber"
                            name="socialInsuranceNumber"
                            type="text"
                            maxLength={9}
                            component={TextInput}
                            placeholder={placeholder}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.socialInsuranceNumber" />}
                            ref={ref => this.setFieldRef("socialInsuranceNumber", ref)}
                        />
                        <Field
                            id="memberGenderType"
                            name="memberGenderType"
                            options={genders}
                            component={SelectInput}
                            disabled={!isEditable || this.props.isArchived}
                            placeholder={placeholder}
                            label={<FormattedMessage id="members.form.memberGenderType" />}
                            ref={ref => this.setFieldRef("memberGenderType", ref)}
                        />
                        <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options">
                            <Field
                                id="languageCode"
                                name="languageCode"
                                component={SelectInput}
                                disabled={!isEditable || this.props.isArchived}
                                label={<FormattedMessage id="members.form.languageCode" />}
                                ref={ref => this.setFieldRef("languageCode", ref)}
                            />
                        </EnumWrapper>
                        {displayIsInternationalField && (
                            <Field
                                id="isInternational"
                                name="isInternational"
                                addBlankOption={true}
                                blankMessageKey="common.nd"
                                options={[
                                    { value: "false", key: "common.no" },
                                    { value: "true", key: "common.yes" },
                                ]}
                                component={NewSelectInput}
                                disabled={!isEditable || this.props.isArchived}
                                label={<FormattedMessage id="members.form.isInternational" />}
                                ref={ref => this.setFieldRef("isInternational", ref)}
                            />
                        )}
                        <Field
                            id="importationDate"
                            name="importationDate"
                            component={DayPicker}
                            disabled={true}
                            utc={true}
                            label={<FormattedMessage id="members.form.importationDate" />}
                            ref={ref => this.setFieldRef("importationDate", ref)}
                        />
                        {
                            // We only want those informations printed for PM clients
                            BU.PM === memberClient.businessAccountType && (
                                <div>
                                    <Field
                                        id="schoolIdentifier"
                                        name="schoolIdentifier"
                                        type="text"
                                        component={TextInput}
                                        placeholder={placeholder}
                                        disabled={!isEditable || this.props.isArchived}
                                        label={<FormattedMessage id="members.form.schoolIdentifier" />}
                                        ref={ref => this.setFieldRef("schoolIdentifier", ref)}
                                    />
                                    <Field
                                        id="personalIdentifier"
                                        name="personalIdentifier"
                                        type="text"
                                        component={TextInput}
                                        placeholder={placeholder}
                                        disabled={!isEditable || this.props.isArchived}
                                        label={<FormattedMessage id="members.form.personalIdentifier" />}
                                        ref={ref => this.setFieldRef("personalIdentifier", ref)}
                                    />
                                    <Field
                                        id="quarter"
                                        name="quarter"
                                        type="text"
                                        component={TextInput}
                                        placeholder={placeholder}
                                        disabled={!isEditable || this.props.isArchived}
                                        label={<FormattedMessage id="members.form.quarter" />}
                                        ref={ref => this.setFieldRef("quarter", ref)}
                                    />
                                </div>
                            )
                        }
                        <Field
                            props={{
                                onChange: (event) => {
                                    this.handleCanadianChange(event);
                                },
                            }}
                            id="isCanadian"
                            name="isCanadian"
                            addBlankOption={true}
                            blankMessageKey="common.nd"
                            options={[
                                { value: "false", key: "common.no" },
                                { value: "true", key: "common.yes" },
                            ]}
                            component={NewSelectInput}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.isCanadian" />}
                            ref={ref => this.setFieldRef("isCanadian", ref)}
                        />
                        {this.state.showHealthCardInput && (
                            <div>
                                <Field
                                    id="provincialHealthNumber"
                                    name="provincialHealthNumber"
                                    type="text"
                                    component={TextInput}
                                    placeholder={placeholder}
                                    required={true}
                                    disabled={!isEditable || this.props.isArchived}
                                    label={<FormattedMessage id="members.form.provincialHealthNumber" />}
                                    ref={ref => this.setFieldRef("provinceHealthNumber", ref)}
                                />
                                <MessageBox key="coverageError" className="alert-warning">
                                    <FormattedMessage id="members.form.error.healthCardInfo" />
                                </MessageBox>
                            </div>
                        )}
                    </div>

                    <div className="member-postal-address">
                        <h3>
                            <FormattedMessage id="members.form.postalAddress" />
                        </h3>
                        <Field
                            id="address"
                            name="address"
                            type="text"
                            component={TextInput}
                            placeholder={placeholder}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.address" />}
                            ref={ref => this.setFieldRef("address", ref)}
                        />
                        <Field
                            id="city"
                            name="city"
                            type="city"
                            component={TextInput}
                            placeholder={placeholder}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.city" />}
                            ref={ref => this.setFieldRef("city", ref)}
                        />
                        <EnumWrapper enum={COUNTRIES} format="inputs" prop="options">
                            <Field
                                props={{
                                    onChange: (e) => {
                                        changeFieldValue("memberForm", "provinceCode", null);
                                        this.handleCountryChange(e);
                                    },
                                }}
                                name="countryCode"
                                id="countryCode"
                                component={SelectInput}
                                disabled={!isEditable || this.props.isArchived}
                                addBlankOption={true}
                                blankMessageKey="common.nd"
                                label={<FormattedMessage id="members.form.country" />}
                                ref={ref => this.setFieldRef("countryCode", ref)}
                            />
                        </EnumWrapper>
                        {countryCode && countryCode !== " " && (
                            <EnumWrapper
                                enum={PROVINCES}
                                query={`filters=provinces.countryCode==${countryCode}`}
                                format="inputs"
                                prop="options"
                            >
                                <Field
                                    id="provinceCode"
                                    name="provinceCode"
                                    component={SelectInput}
                                    disabled={!isEditable || this.props.isArchived}
                                    addBlankOption={true}
                                    blankMessageKey="common.nd"
                                    noOptionsAction={() => {
                                        changeFieldValue("memberForm", "provinceCode", "noProvinces");
                                    }}
                                    label={<FormattedMessage id="members.form.provinceCode" />}
                                    ref={ref => this.setFieldRef("provinceCode", ref)}
                                />
                            </EnumWrapper>
                        )}
                        <Field
                            id="postalCode"
                            name="postalCode"
                            type="text"
                            maxLength="10"
                            component={TextInput}
                            placeholder={placeholder}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.postalCode" />}
                            ref={ref => this.setFieldRef("postalCode", ref)}
                        />
                    </div>

                    <div className="member-client-info">
                        <h3>
                            <FormattedMessage id="members.form.clientInfo" />
                        </h3>
                        <Field
                            id="weeklyHours"
                            name="weeklyHours"
                            type="text"
                            component={TextInput}
                            placeholder={placeholder}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.weeklyHours" />}
                            ref={ref => this.setFieldRef("weeklyHours", ref)}
                        />
                        <Field
                            id="memberPayFrequencyType"
                            name="memberPayFrequencyType"
                            addBlankOption={true}
                            blankMessageKey="common.nd"
                            options={memberPayFrequencies}
                            component={SelectInput}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.memberPayFrequencyType" />}
                            ref={ref => this.setFieldRef("memberPayFrequencyType", ref)}
                        />
                        <Field
                            id="isSmoker"
                            name="isSmoker"
                            addBlankOption={true}
                            blankMessageKey="common.nd"
                            options={[
                                { value: "false", key: "common.no" },
                                { value: "true", key: "common.yes" },
                            ]}
                            component={NewSelectInput}
                            disabled={!isEditable || this.props.isArchived}
                            label={<FormattedMessage id="members.form.isSmoker" />}
                            ref={ref => this.setFieldRef("isSmoker", ref)}
                        />
                        <Render if={memberClient && memberClient.clientBillingPeriodType && memberClient.clientBillingPeriodType.trim() === RECURRING.value}>
                            <Field
                                id="employeeNumber"
                                name="employeeNumber"
                                type="text"
                                component={TextInput}
                                placeholder={placeholder}
                                disabled={!isEditable || this.props.isArchived}
                                label={<FormattedMessage id="members.form.employeeNumber" />}
                                ref={ref => this.setFieldRef("employeeNumber", ref)}
                            />
                        </Render>
                    </div>
                    <button
                        disabled={this.state.areAllFieldsDisabled || submitting || this.state.submittingToggle || this.props.blockSubmit}
                        type="submit"
                        className="btn btn-primary btn-member-profile"
                    >
                        <FormattedMessage id="common.save" />
                    </button>
                </fieldset>
            </form>
        );
    }
}

MemberProfileForm.propTypes = {
    changeFieldValue: PropTypes.func,
    countryCode: PropTypes.string,
    member: PropTypes.object,
    isExistingMemberIdentifier: PropTypes.bool,
    roleId: PropTypes.number,
    isArchived: PropTypes.bool,
    isAllowed: PropTypes.bool,
    disabled: PropTypes.bool,
    submitting: PropTypes.bool,
    handleSubmit: PropTypes.func,
    touch: PropTypes.func,
    blockSubmit: PropTypes.bool,
    formValues: PropTypes.object,
    onSubmit: PropTypes.func,
};

MemberProfileForm.contextTypes = {
    intl: intlShape,
};


function mapStateToProps(state) {
    return {
        formValues: getFormValues("memberForm")(state)
    };
}

export default connect(mapStateToProps, null, null, { withRef: true })(
    reduxForm({
        form: "memberForm",
        validate: (values, props) =>
            validationUtils.validate(values, MemberProfileForm.generateLocalizedRules(values, props.initialValues, props.member)),
    })(MemberProfileForm)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/MemberProfileForm.js